export enum JobFacebookPlacement {
    NewsFeed = 'news_feed',
    Marketplace = 'marketplace',
    RightColumn = 'right_column',
    Reels = 'reels',
    Stories = 'stories',
    InStreamVideos = 'in_stream_videos',
    SearchResults = 'search_results',
}

export const getJobFacebookPlacementDisplayName = (facebookPlacement: JobFacebookPlacement): string => {
    switch (facebookPlacement) {
        case JobFacebookPlacement.NewsFeed:
            return 'News Feed';
        case JobFacebookPlacement.Marketplace:
            return 'Marketplace';
        case JobFacebookPlacement.RightColumn:
            return 'Right Column';
        case JobFacebookPlacement.Reels:
            return 'Reels';
        case JobFacebookPlacement.Stories:
            return 'Stories';
        case JobFacebookPlacement.InStreamVideos:
            return 'In-Stream Videos';
        case JobFacebookPlacement.SearchResults:
            return 'Search Results';
    }
};
